import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation, useQueryClient } from 'react-query';
import { quickVideoKeys } from './quickVideoKeys';
import { useToastError } from 'lib/hooks';
import { successToast } from 'lib/components/toasts/success';
import { useTranslation } from 'react-i18next';

const deleteQuickVideo = async (quickVideoId: number) => {
  return (await EXPRESS_API.delete(`quick-videos/${quickVideoId}`)).data;
};

interface IDeleteQuickVideoParams {
  closeModalHandler?: () => void;
}

export const useDeleteQuickVideoMutation = ({
  closeModalHandler,
}: IDeleteQuickVideoParams) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  const { t } = useTranslation();
  return useMutation((quickVideoId: number) => deleteQuickVideo(quickVideoId), {
    onSuccess: () => {
      successToast({ title: t('Quick Video successfully deleted.') });
      queryClient.invalidateQueries(quickVideoKeys.all());
      if (closeModalHandler) {
        closeModalHandler();
      }
    },
    onError: err => {
      showError(err);
    },
  });
};
